import "./App.css";
import Layout from "./UI/Layout";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Product from "./Pages/Product/Product";
import { ToastContainer } from "react-bootstrap";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Contact from "./Pages/Contact/Contact";
import Career from "./Pages/Career/Career";
import Project from "./Pages/Project/Project";
import ProjectDetails from "./Pages/ProjectDetails/ProjectDetails";
import News from "./Pages/News/News";
import Details from "./Pages/News/Details";
import Techdetails from "./Pages/Details/Techdetails";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/product" element={<Product />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/project" element={<Project />} />
          <Route path="/news" element={<News />} />
          <Route path="/details" element={<Details />} />
          <Route path="/projectdetails" element={<ProjectDetails />} />
          <Route path="/project/techdetails" element={<Techdetails />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
